import * as tslib_1 from "tslib";
import * as shp from 'shpjs';
import { LayerService } from '../services/layer.service';
import * as i0 from "@angular/core";
import * as i1 from "./layer.service";
var ImportService = /** @class */ (function () {
    function ImportService(loggingService, layerService) {
        this.loggingService = loggingService;
        this.layerService = layerService;
        this.loading = null;
        this.shpImportObjectIdFieldName = 'IMPORT_OBJECTID';
    }
    ImportService.prototype.importFiles = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, files, _b, _c, file, content, geoJson, featureSet, e_1_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        files = (e instanceof DragEvent) ? e.dataTransfer.files : e.target.files;
                        this.loading = true;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 8, 9, 10]);
                        _b = tslib_1.__values(Array.from(files)), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 7];
                        file = _c.value;
                        if (!(file.type === 'application/x-zip-compressed')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.readFileAsync(file)];
                    case 3:
                        content = _d.sent();
                        return [4 /*yield*/, shp(content)];
                    case 4:
                        geoJson = _d.sent();
                        featureSet = this.convertGeoJsonToFeatureSet(geoJson);
                        return [4 /*yield*/, this.layerService.addFeatureSetLayerToMap(featureSet)];
                    case 5:
                        _d.sent(); // method returns before work is complete.
                        _d.label = 6;
                    case 6:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 10:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportService.prototype.readFileAsync = function (file) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var fileReader = new FileReader();
                        fileReader.onload = function () {
                            resolve(fileReader.result);
                        };
                        fileReader.onerror = reject;
                        fileReader.readAsArrayBuffer(file);
                    })];
            });
        });
    };
    ImportService.prototype.convertGeoJsonToFeatureSet = function (geoJson) {
        var _this = this;
        var featureCollections = Array.isArray(geoJson) ? tslib_1.__spread(geoJson) : [geoJson];
        var featureSets = featureCollections.flatMap(function (featureCollection) {
            var shpLayer;
            if (featureCollection.features && featureCollection.features.length > 0) {
                // const title = featureCollection.fileName.replace(extension, '').replace(/_+/g, ' ');
                shpLayer = {
                    title: featureCollection.fileName.replace(/_+/g, ' '),
                    objectIdField: _this.shpImportObjectIdFieldName,
                    outFields: ['*'],
                    visible: true
                };
                shpLayer.fields = _this.getFieldsFromGeoJsonAttributes(featureCollection.features[0].properties);
                shpLayer.source = _this.mutateGeoJsonFeaturesToSource(featureCollection.features, shpLayer.fields);
            }
            return shpLayer && shpLayer.source.length > 0 ? [shpLayer] : [];
        });
        return featureSets;
    };
    ImportService.prototype.getFieldsFromGeoJsonAttributes = function (properties) {
        // Detect attribute's JS type and determine ESRI type.
        var js2esri = { '[object Number]': 'double', '[object String]': 'string', '[object Date]': 'date' };
        var fields = Object.entries(properties).map(function (_a) {
            var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
            return ({
                name: key,
                type: js2esri[Object.prototype.toString.call(value)] || 'string'
            });
        });
        // Add a unique identifier to the field list.
        fields.push({
            name: this.shpImportObjectIdFieldName,
            type: 'oid'
        });
        fields.sort(function (a, b) { return a.type === 'oid' ? 1 : a.name.localeCompare(b.name); });
        return fields;
    };
    ImportService.prototype.mutateGeoJsonFeaturesToSource = function (features, fields) {
        // To avoid doubling memory, mutate GeoJSON features into Esri Graphic shape objects
        var i = 0;
        var dateFields = fields.filter(function (field) { return field.type === 'date'; });
        var numberFields = fields.filter(function (field) { return field.type === 'double'; });
        var oidField = fields.filter(function (field) { return field.type === 'oid'; });
        var source = features.flatMap(function (feature) {
            // Convert GeoJSON properties to an ESRI attribute shaped object
            if (feature.properties) {
                feature.attributes = feature.properties;
                delete (feature.properties);
                feature.attributes[oidField[0].name] = i++;
                dateFields.forEach(function (dateField) {
                    // Avoid ESRI API console conversion warning by giving it UTC epoch format date/time.
                    feature.attributes[dateField.name] = feature.attributes[dateField.name].getTime() || null;
                });
                numberFields.forEach(function (numberField) {
                    // Avoid ESRI API console conversion warning by changing NaN values to null.
                    if (Number.isNaN(feature.attributes[numberField.name])) {
                        feature.attributes[numberField.name] = null;
                    }
                });
            }
            // Convert GeoJSON geometry to an ESRI shaped geometry
            if (feature.geometry && feature.geometry.bbox) {
                delete (feature.geometry.bbox);
            }
            if (feature.geometry) {
                switch (feature.geometry.type) {
                    case 'Point':
                        feature.geometry.type = 'point';
                        feature.geometry.x = feature.geometry.coordinates[0];
                        feature.geometry.y = feature.geometry.coordinates[1];
                        break;
                    case 'LineString':
                    case 'MultiLineString':
                        feature.geometry.type = 'polyline';
                        feature.geometry.paths = feature.geometry.coordinates;
                        break;
                    case 'Polygon':
                        feature.geometry.type = 'polygon';
                        feature.geometry.rings = feature.geometry.coordinates;
                        break;
                    case 'MultiPoint':
                        feature.geometry.type = 'multipoint';
                        feature.geometry.points = feature.geometry.coordinates;
                        break;
                    case 'MultiPolygon':
                        // No direct support yet but this approach will atleast allow most/all to display...
                        // Flatten many polygons worth of rings into one polygon with many rings.
                        feature.geometry.type = 'polygon';
                        feature.geometry.rings = feature.geometry.coordinates.flat();
                        break;
                    default:
                        // Not supported
                        return [];
                }
                delete (feature.geometry.coordinates);
                return [feature];
            }
            else {
                return [];
            }
        });
        return source;
    };
    ImportService.ngInjectableDef = i0.defineInjectable({ factory: function ImportService_Factory() { return new ImportService(i0.inject("LoggingService"), i0.inject(i1.LayerService)); }, token: ImportService, providedIn: "root" });
    return ImportService;
}());
export { ImportService };
